export const localState = [
  {
    id: 1,
    texts: [
      {
        id: 1,
        isСrossed: true,
      },
      {
        id: 2,
        isСrossed: true,
      },
      {
        id: 3,
        isСrossed: true,
      },
      {
        id: 4,
        isСrossed: true,
      },
      {
        id: 5,
        isСrossed: true,
      },
    ],
  },
  {
    id: 2,
    texts: [
      {
        id: 1,
        isСrossed: true,
      },
      {
        id: 2,
        isСrossed: true,
      },
      {
        id: 3,
        isСrossed: true,
      },
      {
        id: 4,
        isСrossed: true,
      },
      {
        id: 5,
        isСrossed: true,
      },
      {
        id: 6,
        isСrossed: true,
      },
      {
        id: 7,
        isСrossed: false,
      },
      {
        id: 8,
        isСrossed: true,
      },
    ],
  },
  {
    id: 3,
    texts: [
      {
        id: 1,
        isСrossed: false,
      },
      {
        id: 2,
        isСrossed: true,
      },
      {
        id: 3,
        isСrossed: false,
      },
      {
        id: 4,
        isСrossed: true,
      },
      {
        id: 5,
        isСrossed: false,
      },
      {
        id: 6,
        isСrossed: true,
      },
      {
        id: 7,
        isСrossed: false,
      },
      {
        id: 8,
        isСrossed: false,
      },
      {
        id: 9,
        isСrossed: true,
      },
      {
        id: 10,
        isСrossed: false,
      },
    ],
  },
  {
    id: 4,
    texts: [
      {
        id: 1,
        isСrossed: false,
      },
      {
        id: 2,
        isСrossed: false,
      },
      {
        id: 3,
        isСrossed: false,
      },
      {
        id: 4,
        isСrossed: false,
      },
      {
        id: 5,
        isСrossed: false,
      },
    ],
  },
  {
    id: 5,
    texts: [
      {
        id: 1,
        isСrossed: false,
      },
      {
        id: 2,
        isСrossed: false,
      },
      {
        id: 3,
        isСrossed: false,
      },
      {
        id: 4,
        isСrossed: false,
      },
      {
        id: 5,
        isСrossed: false,
      },
      {
        id: 6,
        isСrossed: false,
      },
      {
        id: 7,
        isСrossed: false,
      },
    ],
  },
  {
    id: 6,
    texts: [
      {
        id: 1,
        isСrossed: false,
      },
      {
        id: 2,
        isСrossed: false,
      },
    ],
  },
];
